import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import he from 'he';

class StrippedText extends PureComponent {
    static propTypes = {
        allowHtmlCharacters: PropTypes.bool,
        text: PropTypes.string.isRequired,
        className: PropTypes.string
    };

    static defaultProps = {
        allowHtmlCharacters: true
    };

    // Function to remove any html tags
    stripHtml = html => {
        const strippedHtml = html.replace(/<[^>]+>/g, '');
        return strippedHtml;
    };

    render() {
        const {allowHtmlCharacters, text, className} = this.props;

        if (allowHtmlCharacters) {
            return <div className={className}>{he.decode(this.stripHtml(text))}</div>;
        }
        return <div className={className}>{this.stripHtml(text)} </div>;
    }
}

export default StrippedText;
